import {
  EDITING_DOCUMENTS_LIST_FETCH_FAILURE,
  EDITING_DOCUMENTS_LIST_FETCH_REQUEST,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsIsListFetchingState = boolean;

const initialState: EditingDocumentsIsListFetchingState = false;

export default function reducer(
  state: EditingDocumentsIsListFetchingState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_LIST_FETCH_REQUEST:
      return true;
    case EDITING_DOCUMENTS_LIST_FETCH_SUCCESS:
    case EDITING_DOCUMENTS_LIST_FETCH_FAILURE:
      return false;
    default:
      return state;
  }
}
